<template>
<div>
    <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
    <audio controls>
        <source :src="audio(data)" :type="data.mime">
    </audio>
</div>
</template>

<script>
export default {
    name: 'ContentAudio',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        audio({
            host,
            original_file,
        }, size = 'original') {
            // Verificar se temos uma URL assinada disponível no localStorage
            const signedUrls = localStorage.getItem(`content_${this.data.id_lesson_content}_download_urls`);

            if (signedUrls) {
                const urls = JSON.parse(signedUrls);
                if (urls && urls.show) {
                    // Se temos uma URL assinada para visualização, usamos ela
                    return urls.show;
                }
            }

            return `/app/files/download/${this.data.id_lesson_content}/${this.data.secret}/show`;
        },
    },

};
</script>
